import { NodeType } from '../../types'
import type { StartNodeTrigger } from './start.types'

// Re-exported for existing consumers; new code should import straight from
// `./start.types` so it doesn't pull the node definitions below back in.
export type { StartNodeTrigger }

export const startNodeTriggerLabel: Record<StartNodeTrigger, string> = {
  QUOTE_REQUIRES_APPROVAL: 'Quote approval',
  CONTRACT_UPLOADED: 'Contract uploaded',
  INVOICE_SENT: 'Invoice sent'
}

export const startNodeTriggerTargetDefinition: Record<
  StartNodeTrigger,
  NodeType
> = {
  QUOTE_REQUIRES_APPROVAL: 'START_QUOTE_REQUIRES_APPROVAL',
  CONTRACT_UPLOADED: 'START_CONTRACT_UPLOADED',
  INVOICE_SENT: 'START_INVOICE_SENT'
}

export { startQuoteRequiresApprovalNodeDefinition } from './startQuoteRequiresApproval'
export { startContractUploadedNodeDefinition } from './startContractUploaded'
export { startInvoiceSentNodeDefinition } from './startInvoiceSent'
export { startPlaceholderNodeDefinition } from './startPlaceholder'
